/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable sonarjs/no-duplicate-string */

import React from 'react';
import { formatter, validateData } from '../../constants/CommonMethods';
// import { PageStyles } from './PageStyles';
import { formStyles } from '../../components/componentstyles/formstyles';
import { ReactComponent as QRCode } from '../../assets/images/qr-code-mx.svg';
import { useTranslation } from 'react-i18next';
export interface itemPrintProps {
  printItemNo: any[];
  printLanguage: string;
  printItemResp: any;
  invRefCodes?: any;
}

const Barcode = require('react-barcode');
const sprintf = require('sprintf-js').sprintf;
export default function PrintFunction(props: itemPrintProps) {




  const formClasses = formStyles();
  const storeDetails = sessionStorage.getItem('storeDetails') || '';
  const encodestore = Buffer.from(storeDetails, 'base64');
  const decodestore: any = JSON.parse(encodestore.toString('utf-8'));
  console.log('inside Print Function', props);
  const {t} = useTranslation('PriceTag');
  console.log('decodestore', decodestore);
  const data = validateData(props.printItemResp) ? props.printItemResp : [];
  console.log('responsedata', data);

  const formatEpoPercentage = (value: any): string => {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return String(value).trim();
    }

    return Number(numericValue.toFixed(2)).toString();
  };

  const PriceTag = () => {
    return props.printItemNo.map((values: any, index: any) => {
      // console.log('generateBarCodeContent',generateBarCodeContent(data[index].inventoryPriceId, props?.invRefCodes?.depRefCode, props?.invRefCodes?.subDepRefCode));subDeptRefcode

      if (
        validateData(data[index]) &&
        validateData(data[index].weeklyRate) &&
        validateData(data[index].brand)
      ) {
        const costRental = Number(data[index].totalCost) - Number(data[index].sameAsCashPrice);
        // const SplitweeklyRate = data[index].weeklyRate.split('.');
        const SplitweeklyRate = Number(data[index]?.weeklyRate)?.toFixed(2)?.split('.');
        const brand = data[index].brand.toUpperCase();
        const monthmain = (Number(data[index].totalCost)) / (Number(data[index].monthlyRate))
        if (data[index]?.templateName == "SingleItemPriceTag_new") {
          return (

            <div key={index} style={{ fontFamily: 'Arial', marginTop: '0% important' }}>
              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '25px', textAlign: 'center', paddingTop: index > 0 ? '20px' : '' }}>
                  {validateData(brand) ? brand : '-'}
                </h1>{

                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', display: 'inline-block' }}>
                      <span style={{ fontSize: '70px', fontWeight: 'bold', position: 'relative', top: '-44px' }}>$</span>
                      <span style={{ fontSize: '138px', fontWeight: 'bold' }}>
                        {validateData(SplitweeklyRate[0]) ? SplitweeklyRate[0] : ' - '}
                      </span>
                    </div>
                    <div style={{ textAlign: 'center', marginLeft: '8px' }}>
                      <p style={{ fontSize: '70px', fontWeight: 'bold', marginBottom: '10px', marginTop: '15px' }}>
                        {validateData(SplitweeklyRate[1]) ? SplitweeklyRate[1] : ' - '}
                      </p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('PER WEEK')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : '-'}{' '}
                        {t('Payments')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('to Own It')}</p>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '21px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '24px', marginBottom: '10px' }}>{t('Additional Flexible Payment Options:')}</p>
                <div style={{ width: '100%', float: 'left', marginBottom: '15px' }}>
                  <div style={{ width: '33%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Bi-weekly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter.format(data[index].biWeeklyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? (data[index].biWeeklyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Semi-monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter.format(data[index].semiMonthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,
                      </span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? (data[index].semiMonthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter.format(data[index].monthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? (data[index].monthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <p style={{ fontSize: '22px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '10px', marginBottom: '6px' }}>{t('Easy Ownership Options:')}</p>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '18px' }}>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} {t('Days')} &nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: 'bold' }}>{t('Same As Cash Price (SAC):')}&nbsp;</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '18px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('After SAC:')}&nbsp;</span>
                  <span><span style={{ fontWeight: 'bold' }}>{formatEpoPercentage(data[index].epoPercentage)} % </span> {t('off remaining total')}</span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: data[index]?.inventoryDescription?.length <= 62 ? '40px' : '48px', fontSize: '18px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('Total Cost:')} </span>
                  <span>

                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter.format(data[index].weeklyRate).replace(/^(\D+)/, '$1 ')
                      : '-'}{' '}
                    x{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : '-'}{' '}
                  </span>
                  <span>{t('payments =')}</span>
                  <span>{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter.format(data[index].totalCost).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                   
                <div style={{ width: '100%', textAlign: 'center'}}>
                  
                  <p style={{ textAlign: 'center', fontSize: '22px', marginBottom: '23px', marginTop: '28px', marginLeft: '13px' }}>
                    <span style={{height:"14px", display:'block'}}></span>
                   <span style={{display:'block'}}> {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : '-'}{'  '}
                    {/* Previously Rented */}</span>
                  </p>
                  <div className="text-align:center;width:100%" style={{ marginTop: '3px' }}>
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Item:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : '-'}{'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Model:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : '-'}
                        {'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Serial:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : '-'}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} >
                    <Barcode width={1.5} value={generateBarCodeContent(data[index].inventoryPriceId, data[index].deptRefcode, data[index].subDeptRefcode)} displayValue={true} height={48} fontSize={7} format='CODE128' />{' '}
                  </div>
                </div>
              </div>
            </div>
          )
        }
        else if (data[index]?.templateName == "SingleItemPriceTag_n2") {
          return (
            <div
              key={index}
              style={{
                fontFamily: "Arial",
                marginTop: "0% important",
              }}
            >
              <div style={{ width: "100%" }}>
                <h1
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    paddingTop: index > 0 ? "20px" : '',
                  }}
                >
                  {validateData(brand) ? brand : "-"}
                </h1>
                {

                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", display: "inline-block" }}
                    >
                      <span
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-44px",
                        }}
                      >
                        $
                      </span>
                      <span style={{ fontSize: "138px", fontWeight: "bold" }}>
                        {validateData(SplitweeklyRate[0])
                          ? SplitweeklyRate[0]
                          : " - "}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginLeft: "8px" }}>
                      <p
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        {validateData(SplitweeklyRate[1])
                          ? SplitweeklyRate[1]
                          : " - "}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('PER WEEK')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('to Own It')}
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "21px",
                    marginBottom: "10px",
                  }}
                >
                  {t('Additional Flexible Payment Options:')}
                </p>
                <div
                  style={{ width: "100%", float: "left", marginBottom: "15px" }}
                >
                  <div
                    style={{
                      width: "33%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Bi-weekly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter
                            .format(data[index].biWeeklyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? data[index].biWeeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "32%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Semi-monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter
                            .format(data[index].semiMonthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? data[index].semiMonthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: "32%", float: "left" }}>
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter
                            .format(data[index].monthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? data[index].monthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "9px",
                    marginBottom: "6px",
                  }}
                >
                  {t('Easy Ownership Options:')}
                </p>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "7px",
                    fontSize: "17px",
                  }}
                >

                  {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} Days&nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: "bold" }}>
                    {t('Same As Cash Price (SAC):')}&nbsp;
                  </span>
                  <span style={{ fontWeight: "bold" }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter
                        .format(data[index].sameAsCashPrice)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "7px",
                    fontSize: "16px",
                    marginLeft: "3px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{t('After SAC:')}&nbsp;</span>
                  <span>
                    <span style={{ fontWeight: "bold" }}></span>{t('Purchase early to save on the total cost')}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "53px",
                    fontSize: "17px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{t('Total Cost:')} </span>
                  <span>
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter
                        .format(data[index].weeklyRate)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}{" "}
                    x{" "}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : "-"}{" "}
                  </span>
                  <span>{t('payments =')}</span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter
                        .format(data[index].totalCost)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                </div>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "22px",
                      fontWeight: "bold",
                      marginBottom: "30px",
                      marginTop: "42px",
                      marginLeft: "13px",
                    }}
                  >
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : "-"}
                    {"  "}
                    {/* Previously Rented */}
                  </p>
                  <div className="text-align:center;width:100%">
                    {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Item:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Model:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Serial:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : "-"}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix}>
                    <Barcode width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={true}
                      height={48}
                      fontSize={7}
                      format="CODE128"
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if (data[index]?.templateName == "MESingleItemPriceTag_n") {
          return (
            <div
              key={index}
              style={{ fontFamily: "Arial", marginTop: "0% important" }}
            >
              <div style={{ width: "100%" }}>
                <h1
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    paddingTop: index > 0 ? '20px' : ''
                  }}
                >
                  {validateData(brand) ? brand : "-"}
                </h1>
                {

                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", display: "inline-block" }}
                    >
                      <span
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-44px",
                        }}
                      >
                        $
                      </span>
                      <span style={{ fontSize: "138px", fontWeight: "bold" }}>
                        {validateData(SplitweeklyRate[0])
                          ? SplitweeklyRate[0].length >= 2 ? SplitweeklyRate[0] : (SplitweeklyRate[0] + ' ')
                          : " - "}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginLeft: "8px" }}>
                      <p
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        {validateData(SplitweeklyRate[1])
                          ? SplitweeklyRate[1]
                          : " - "}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('PER WEEK')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('+ Purchase Option')}
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginBottom: "9px",
                  }}
                >
                  {t('Additional Flexible Payment Options:')}
                </p>
                <div
                  style={{ width: "100%", float: "left", marginBottom: "15px" }}
                >
                  <div
                    style={{
                      width: "33%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Bi-weekly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter
                            .format(data[index]?.biWeeklyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? data[index].biWeeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "32%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Semi-monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter
                            .format(data[index].semiMonthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? data[index].semiMonthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "32%", float: "left" }}>
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter
                            .format(data[index].monthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? data[index].monthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    ></div>
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    // marginTop: "6px",
                    marginBottom: "6px",
                  }}
                >
                  {t('Easy Ownership Options:')}
                </p>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "4px",
                    fontSize: "16px",
                  }}
                >
                  <span>
                    <span style={{ fontWeight: "bold" }}>{t('Cash Price:')}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {validateData(data[index]) &&
                        validateData(data[index].sameAsCashPrice)
                        ? formatter
                          .format(data[index].sameAsCashPrice)
                          .replace(/^(\D+)/, "$1 ")
                        : "-"}
                    </span>
                    &nbsp;
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {t('Same As Cash Price (SAC) + Purchase Option')}
                  </span>
                </div>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) && Number(data[index].sacDaysToPrint) > 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "15px",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {data[index].sacDaysToPrint}&nbsp;
                    </span>
					          <span style={{ fontWeight: "bold" }}>
                      {t('Days SAC')}
                    </span>
                  </div>
                )}              
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "4px",
                    fontSize: "16px",
                    // marginTop: "35px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{t('After SAC:')}&nbsp;</span>
                  <span>{t('Purchase early to save')}&nbsp;</span>
                  <span>
                    <span style={{ fontWeight: 'bold' }}>{formatEpoPercentage(data[index].epoPercentage)} % {t('of')}</span>{" "} {t('remaining rent')}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "36px",
                    fontSize: "16px",
                    // marginTop: "3px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {t('Total Rental Cost:')}{" "}
                  </span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter
                        .format(data[index].totalCost)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                  <span> + </span>
                  <div style={{ marginTop: "4px", marginBottom: '32px' }}>
                    {" "}
                    <span style={{ fontWeight: "bold" }}>
                      {t('End-of-Lease Purchase Option')} &nbsp;
                    </span>
                    <span>
                      {validateData(data[index]) &&
                        validateData(data[index].totalCost)
                        ? formatter
                          .format(data[index].totalCost)
                          .replace(/^(\D+)/, "$1 ")
                        : "-"}
                    </span>
                  </div>
                </div>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "22px",
                      fontWeight: "bold",
                      marginBottom: "30px",
                      marginTop: "27px",
                    }}
                  >
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : "-"}
                    {"  "}
                  </p>
                  <div className="text-align:center;width:100%">
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Item:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Model:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Serial:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : "-"}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix}>
                    <Barcode
                      width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={true}
                      height={48}
                      fontSize={7}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          )
        }
        else if (data[index]?.templateName == 'NCSingleItemPriceTag_n') {
          return (
            <div
              key={index}
              style={{ fontFamily: "Arial", marginTop: "0% important" }}
            >
              <div style={{ width: "100%" }}>
                <h1
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    paddingTop: index > 0 ? '20px' : '',
                  }}
                >
                  {validateData(brand) ? brand : "-"}
                </h1>
                {

                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", display: "inline-block" }}
                    >
                      <span
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-44px",
                        }}
                      >
                        $
                      </span>
                      <span style={{ fontSize: "138px", fontWeight: "bold" }}>
                        {validateData(SplitweeklyRate[0])
                          ? SplitweeklyRate[0]?.length >= 2 ? SplitweeklyRate[0] : (SplitweeklyRate[0] + ' ')
                          : " - "}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginLeft: "8px" }}>
                      <p
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        {validateData(SplitweeklyRate[1])
                          ? SplitweeklyRate[1]
                          : " - "}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('PER WEEK')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('+ Purchase Option')}
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginBottom: "9px",
                  }}
                >
                  {t('Additional Flexible Payment Options:')}
                </p>
                <div
                  style={{ width: "100%", float: "left", marginBottom: "15px" }}
                >
                  <div
                    style={{
                      width: "33%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Bi-weekly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter
                            .format(data[index]?.biWeeklyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? data[index].biWeeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "32%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Semi-monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter
                            .format(data[index].semiMonthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? data[index].semiMonthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "32%", float: "left" }}>
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "5px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter
                            .format(data[index].monthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? data[index].monthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                      <div
                        style={{
                          marginLeft: "5px",
                          fontSize: "14px",
                          marginTop: "3px",
                        }}
                      >
                        {t('+ Purchase Option')}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    ></div>
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    // marginTop: "6px",
                    marginBottom: "6px",
                  }}
                >
                  {t('Easy Ownership Options:')}
                </p>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "4px",
                    fontSize: "16px",
                  }}
                >
                  <span>
                    <span style={{ fontWeight: "bold" }}>{t('Cash Price:')}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {validateData(data[index]) &&
                        validateData(data[index].sameAsCashPrice)
                        ? formatter
                          .format(data[index].sameAsCashPrice)
                          .replace(/^(\D+)/, "$1 ")
                        : "-"}
                    </span>
                    &nbsp;
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    {t('Same As Cash Price (SAC) + Purchase Option')}
                  </span>
                </div>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) && Number(data[index].sacDaysToPrint) > 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      //marginBottom: "7px",
                      fontSize: "15px",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {data[index].sacDaysToPrint}&nbsp;
                    </span>
					          <span style={{ fontWeight: "bold" }}>
                      {t('Days SAC')}
                    </span>
                  </div>
                )}
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "4px",
                    fontSize: "16px",
                    // marginTop: "35px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{t('After SAC:')}&nbsp;</span>
                  <span>{t('Purchase early to save')}&nbsp;</span>
                  <span>
                    <span style={{ fontWeight: 'bold' }}>{formatEpoPercentage(data[index].epoPercentage)} % {t('of')}</span>{" "} {t('remaining rent')}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    // marginBottom: "36px",
                    fontSize: "16px",
                    // marginTop: "3px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {t('Total Rental Cost:')}{" "}
                  </span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter
                        .format(data[index].totalCost)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                  <span> + </span>
                  <div style={{ marginTop: "4px", marginBottom: '23px' }}>
                    {" "}
                    <span style={{ fontWeight: "bold" }}>
                      {t('End-of-Lease Purchase Option')} &nbsp;
                    </span>
                    <span>
                      {validateData(data[index]) &&
                        validateData(data[index]?.noteTotalCost)
                        ? formatter
                          .format(data[index].noteTotalCost)
                          .replace(/^(\D+)/, "$1 ")
                        : "-"}
                    </span>
                  </div>
                </div>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "22px",
                      fontWeight: "bold",
                      marginBottom: "30px",
                      marginTop: "20px",
                    }}
                  >
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : "-"}
                    {"  "}
                  </p>
                  <div className="text-align:center;width:100%">
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Item:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Model:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Serial:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : "-"}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix}>
                    <Barcode
                      width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={true}
                      height={48}
                      fontSize={7}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          )
        }
        else if (data[index]?.templateName == "IASingleItemPriceTag_n") {
          return (
            <div key={index}
              style={{ fontFamily: 'Arial', marginTop: '0% important' }}>
              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '25px', textAlign: 'center', paddingTop: index > 0 ? '20px' : '', }}>
                  {validateData(brand) ? brand : '-'}
                </h1>
                {
                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '26px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', display: 'inline-block' }}>
                      <span style={{ fontSize: '70px', fontWeight: 'bold', position: 'relative', top: '-44px' }}>$</span>
                      <span style={{ fontSize: '136px', fontWeight: 'bold' }}>
                        {validateData(SplitweeklyRate[0]) ? SplitweeklyRate[0] : ' - '}
                      </span>
                    </div>
                    <div style={{ textAlign: 'center', marginLeft: '8px' }}>
                      <p style={{ fontSize: '70px', fontWeight: 'bold', marginBottom: '10px', marginTop: '15px' }}>
                        {validateData(SplitweeklyRate[1]) ? SplitweeklyRate[1] : ' - '}
                      </p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('PER WEEK')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : '-'}{' '}
                        {t('Payments')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('to Own It')}</p>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '19px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '17px', marginBottom: '8px' }}>{t('Additional Flexible Payment Options:')}</p>
                <div style={{ width: '100%', float: 'left', marginBottom: '15px', borderBottom: '1px solid #000' }}>
                  <div style={{ width: '33%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Bi-weekly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter.format(data[index].biWeeklyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? (data[index].biWeeklyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Semi-monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter.format(data[index].semiMonthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,
                      </span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? (data[index].semiMonthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter.format(data[index].monthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? (data[index].monthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <p style={{ fontSize: '17px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginBottom: '5px' }}>{t('Easy Ownership Options:')}</p>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '4px', fontSize: '16px' }}>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} {t('Days')}&nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: 'bold' }}>{t('Same As Cash Price (SAC):')}&nbsp;</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '6px', fontSize: '16px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('After SAC:')}&nbsp;</span>
                  <span><span>{t('Purchase early to')}</span> {t('save on the total cost.')}</span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '33px', fontSize: '17px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('Total Cost:')} </span>
                  <span>

                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter.format(data[index].weeklyRate).replace(/^(\D+)/, '$1 ')
                      : '-'}{' '}
                    x{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : '-'}{' '}
                  </span>
                  <span>{t('payments =')}</span>
                  <span>{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter.format(data[index].totalCost).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                  <div style={{ border: '1px solid #000' }}></div>
                  <div style={{ textAlign: 'left' }}>
                    <span style={{ fontSize: '11px' }}>{t('This is consumer rental purchase agreement. You will not own the property untill the total cost paid in full or you exercise your early purchase option as provided by lowa law.')}</span>
                  </div>
                </div>

                <div style={{ width: '100%', textAlign: 'center' }}>
                  <p style={{ textAlign: 'center', fontSize: '22px', fontWeight: 'bold', marginBottom: '29px', marginTop: '19px' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : '-'}{'  '}
                    {/* Previously Rented */}
                  </p>
                  <div className="text-align:center;width:100%" style={{ fontSize: '12px' }}>
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span>{t('Item:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : '-'}{'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>Model: </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : '-'}
                        {'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>{t('Serial:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : '-'}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} >
                    <Barcode width={1.5} value={generateBarCodeContent(data[index].inventoryPriceId, data[index].deptRefcode, data[index].subDeptRefcode)} displayValue={true} height={48} fontSize={7} />{' '}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if (data[index]?.templateName == "PRSingleItemPriceTag_n_es") {
          return (
            <div
              key={index}
              style={{ fontFamily: "Arial", marginTop: "0% important" }}
            >
              <div style={{ width: "100%" }}>
                <h1
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    paddingTop: index > 0 ? "20px" : '',
                    marginRight: "70px",
                  }}
                >
                  {validateData(brand) ? brand : "-"}
                </h1>
                {

                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px', marginRight: "71px" }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px', marginRight: "71px" }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", display: "inline-block" }}
                    >
                      <span
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-44px",
                        }}
                      >
                        $
                      </span>
                      <span style={{ fontSize: "138px", fontWeight: "bold" }}>
                        {validateData(SplitweeklyRate[0])
                          ? SplitweeklyRate[0]
                          : " - "}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginLeft: "8px" }}>
                      <p
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        {validateData(SplitweeklyRate[1])
                          ? SplitweeklyRate[1]
                          : " - "}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        SEMANALES*
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : "-"}{" "}
                        pagos para
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        que sea tuyo
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "21px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "24px",
                    marginBottom: "10px",
                  }}
                >
                  más opciones de pagos flexibles:
                </p>
                <div
                  style={{
                    width: "100%",
                    float: "left",
                    marginBottom: "15px",
                    // borderBottom: "1px solid #000",
                  }}
                >
                  <div
                    style={{
                      width: "33%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      Bisemanales
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter
                            .format(data[index].biWeeklyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}*
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? data[index].biWeeklyTerm
                          : "-"}{" "}
                        pagos
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "32%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      Quincenales
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter
                            .format(data[index].semiMonthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}*
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? data[index].semiMonthlyTerm
                          : "-"}{" "}
                        pagos
                      </span>
                    </div>
                  </div>
                  <div style={{ width: "32%", float: "left" }}>
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      Mensuales
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter
                            .format(data[index].monthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}*
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? data[index].monthlyTerm
                          : "-"}{" "}
                        pagos
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "17px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "6px",
                  }}
                >
                  Opciones sencillas para adquirir el derecho de propiedad
                </p>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "5px",
                    fontSize: "18px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>Precio en efectivo:&nbsp;</span>
                  <span style={{ fontWeight: "bold" }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter
                        .format(data[index].sameAsCashPrice)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}*
                  </span>
                </div>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) && Number(data[index].sacDaysToPrint) > 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      //marginBottom: "7px",
                      fontSize: "15px",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {data[index].sacDaysToPrint}&nbsp;
                    </span>
					          <span style={{ fontWeight: "bold" }}>
                      Días de precio en efectivo
                    </span>
                  </div>
                )}
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "5px",
                    fontSize: "17px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>50% de descuento:&nbsp;</span>
                  <span>
                    <span>del saldo descuento</span>
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "45px",
                    fontSize: "17px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>Precio total: </span>
                  <span>
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter
                        .format(data[index].weeklyRate)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}{" "}
                    x{" "}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : "-"}{" "}
                  </span>
                  <span>pagos =</span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter
                        .format(data[index].totalCost)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}*
                  </span>
                </div>

                <div style={{ width: "100%", textAlign: "center" }}>
                  {data != undefined && data[index].status == 'Previously Rented' ?
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: "bold",
                        marginBottom: "28px",
                        marginTop: "14px",
                      }}
                    >
                      Previamente Alquilado
                    </p> :
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: "bold",
                        marginBottom: "25px",
                        marginTop: "20px",
                      }}
                    >
                      Nuevo
                    </p>}
                  <div style={{ fontSize: '9px' }}>Impuestos No Includes*</div>
                  <div className="text-align:center;width:100%" style={{ fontSize: '7px' }}>
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: "8px" }}>Articulo: </span>
                      <span style={{ fontSize: "8px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "8px" }}>Modelo: </span>
                      <span style={{ fontSize: "8px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "8px" }}>Serie: </span>
                      <span style={{ fontSize: "8px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : "-"}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} style={{ marginTop: '-2px' }}>
                    <Barcode
                      width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={true}
                      format={"CODE128"}
                      height={48}
                      fontSize={7}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if (data[index]?.templateName == "PASingleItemPriceTag_n") {
          return (
            <div key={index}
              style={{ fontFamily: 'Arial', marginTop: '0% important' }}>
              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '25px', textAlign: 'center', paddingTop: index > 0 ? '22px' : '' }}>
                  {validateData(brand) ? brand : '-'}
                </h1>
                {
                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '27px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', display: 'inline-block' }}>
                      <span style={{ fontSize: '70px', fontWeight: 'bold', position: 'relative', top: '-44px' }}>$</span>
                      <span style={{ fontSize: '138px', fontWeight: 'bold' }}>
                        {validateData(SplitweeklyRate[0]) ? SplitweeklyRate[0] : ' - '}
                      </span>
                    </div>
                    <div style={{ textAlign: 'center', marginLeft: '8px' }}>
                      <p style={{ fontSize: '70px', fontWeight: 'bold', marginBottom: '10px', marginTop: '15px' }}>
                        {validateData(SplitweeklyRate[1]) ? SplitweeklyRate[1] : ' - '}
                      </p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('PER WEEK')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : '-'}{' '}
                        {t('Payments')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('to Own It')}</p>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '19px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '22px', marginBottom: '8px' }}>{t('Additional Flexible Payment Options:')}</p>
                <div style={{ width: '100%', float: 'left', marginBottom: '15px' }}>
                  <div style={{ width: '33%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Bi-weekly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter.format(data[index].biWeeklyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? (data[index].biWeeklyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Semi-monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter.format(data[index].semiMonthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,
                      </span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? (data[index].semiMonthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter.format(data[index].monthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? (data[index].monthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '18px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('Cost of Lease Services:')}&nbsp;</span>
                  <span> {validateData(data[index]) &&
                    validateData(data[index].costOfRental)
                    ? formatter.format(data[index].costOfRental).replace(/^(\D+)/, '$1 ')
                    : '-'}</span>
                </div>
                <p style={{ fontSize: '18px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '5px', marginBottom: '5px' }}>{t('Easy Ownership Options:')}</p>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '17px' }}>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} {t('Days')}&nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: 'bold' }}>{t('Same As Cash Price (SAC):')}&nbsp;</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '17px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('After SAC:')}&nbsp;</span>
                  <span><span>{t('Purchase early to save')}</span> {t('on the total cost.')}</span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '31px', fontSize: '17px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('Total Cost:')} </span>
                  <span>

                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter.format(data[index].weeklyRate).replace(/^(\D+)/, '$1 ')
                      : '-'}{' '}
                    x{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : '-'}{' '}
                  </span>
                  <span>{t('payments =')}</span>
                  <span>{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter.format(data[index].totalCost).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <p style={{ textAlign: 'center', fontSize: '22px', fontWeight: 'bold', marginBottom: '30px', marginTop: '21px' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : '-'}{'  '}
                    {/* Previously Rented */}
                  </p>
                  <div className="text-align:center;width:100%" style={{ fontSize: '12px' }}>
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span>{t('Item:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : '-'}{'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>{t('Model:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : '-'}
                        {'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>{t('Serial:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : '-'}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} >
                    <Barcode width={1.5} value={generateBarCodeContent(data[index].inventoryPriceId, data[index].deptRefcode, data[index].subDeptRefcode)} displayValue={true} height={48} fontSize={7} />{' '}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if (data[index]?.templateName == "VTSingleItemPriceTag_n") {
          return (
            <div style={{ fontFamily: 'Arial', marginTop: '0% important' }}>
              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '25px', textAlign: 'center', paddingTop: index > 0 ? '20px' : '' }}>
                  {validateData(brand) ? brand : '-'}
                </h1>
                {
                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '26px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', display: 'inline-block' }}>
                      <span style={{ fontSize: '70px', fontWeight: 'bold', position: 'relative', top: '-44px' }}>$</span>
                      <span style={{ fontSize: '138px', fontWeight: 'bold' }}>
                        {validateData(SplitweeklyRate[0]) ? SplitweeklyRate[0] : ' - '}
                      </span>
                      <p style={{ margin: '0' }}>
                        {t('WAS:$25.99, 77 Payments')}
                      </p>
                    </div>
                    <div style={{ textAlign: 'center', marginLeft: '8px' }}>
                      <p style={{ fontSize: '70px', fontWeight: 'bold', marginBottom: '10px', marginTop: '15px' }}>
                        {validateData(SplitweeklyRate[1]) ? SplitweeklyRate[1] : ' - '}
                      </p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('PER WEEK')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : '-'}{' '}
                        {t('Payments')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('to Own It')}</p>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '17px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '15px', marginBottom: '10px' }}>{t('Additional Flexible Payment Options:')}</p>
                <div style={{ width: '100%', float: 'left', marginBottom: '15px', borderBottom: '1px solid #000' }}>
                  <div style={{ width: '33%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Bi-weekly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter.format(data[index].biWeeklyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? (data[index].biWeeklyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Semi-monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter.format(data[index].semiMonthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,
                      </span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? (data[index].semiMonthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter.format(data[index].monthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? (data[index].monthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ width: '100%', marginBottom: '7px', fontSize: '16px' }}>
                  <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{t('Cash Price + Rent-to-Own Charge = Total Cost of OwnerShip')}&nbsp;</div>
                  <div style={{ width: '100%' }}>
                    <div style={{ width: '33.3%', float: 'left' }}>{validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}</div>
                    <div style={{ width: '33.3%', float: 'left' }}> {validateData(data[index]) &&
                      validateData(data[index].costOfRental)
                      ? formatter.format(data[index].costOfRental).replace(/^(\D+)/, '$1 ')
                      : '-'}</div>
                    <div style={{ width: '33.3%', float: 'left' }}> {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter.format(data[index].totalCost).replace(/^(\D+)/, '$1 ')
                      : '-'}</div>
                  </div>
                </div>
                <div style={{ border: '1px solid #000', marginBottom: '0px', marginTop: '25px' }}></div>
                <p style={{ fontSize: '17px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '0px', marginBottom: '0px' }}>{t('Easy Ownership Options:')}</p>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '0px', fontSize: '16px' }}>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} {t('Days')}&nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: 'bold' }}>{t('Same As Cash Price (SAC):')}&nbsp;</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '16px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('After SAC:')}&nbsp;</span>
                  <span><span>{t('Purchase early to')}</span> {t('save on total cost of ownership')}</span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '0px', fontSize: '0px' }}>
                  <div style={{ border: '1px solid #000' }}></div>
                  <div style={{ textAlign: 'left' }}>
                    <span style={{ fontSize: '12px' }}>{t('This is rent-to-own agreement. You will not own the merchandise until the total cost of ownership is paid in full or you exercise your early purchase option')}</span>
                  </div>
                </div>

                <div style={{ width: '100%', textAlign: 'center' }}>
                  {data[index]?.savingsAmount == undefined ?
                    <div>
                      <p style={{ textAlign: 'center', fontSize: '22px', fontWeight: 'bold', marginBottom: '30px', marginTop: '20px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].status)
                          ? data[index].status
                          : '-'}{'  '}
                      </p>
                    </div> :
                    <div style={{ width: '100%', float: 'left', fontSize: '11px', display: 'flex', marginBottom: '3px' }}>
                      <div style={{ width: '83%', float: 'left', textAlign: 'right' }}>
                        <p style={{ marginTop: '20px', marginBottom: '0', marginRight: '30px' }}>
                          {validateData(data[index]) &&
                            validateData(data[index].status)
                            ? data[index].status
                            : '-'}{'  '} <span>{validateData(data[index]) &&
                              validateData(data[index].timesRented)
                              ? (data[index].timesRented)
                              : '-'}{' '} {t('times')}</span>
                          {/* Previously Rented */}
                        </p>
                        <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>YOU SAVE{validateData(data[index]) &&
                          validateData(data[index].savingsAmount)
                          ? formatter.format(data[index].savingsAmount).replace(/^(\D+)/, ' $1 ')
                          : '-'}</p>
                        <p style={{ marginTop: '0', marginRight: '55px' }}>{t('compared to new')}</p>
                      </div>
                      <div style={{ width: '35%', float: 'left', marginTop: '20px', textAlign: 'left', paddingLeft: '18%' }}>
                        <div>
                          {t('Acquired')}
                        </div>
                        <div>{t('by RAC on')} </div>
                        <div>01/07/2023</div>
                      </div>
                    </div>
                  }

                  <div className="text-align:center;width:100%" style={{ fontSize: '12px', marginTop: '-1px' }}>
                    {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span>{t('Item:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : '-'}{'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>{t('Model:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : '-'}
                        {'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span>{t('Serial:')} </span>
                      <span>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : '-'}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} style={{ marginTop: '-2px' }} >
                    <Barcode width={1.5} value={generateBarCodeContent(data[index].inventoryPriceId, data[index].deptRefcode, data[index].subDeptRefcode)} displayValue={true} height={48} fontSize={7} />{' '}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if (data[index]?.templateName == 'WVSingleItemPriceTag_n') {
          return (
            <div
              key={index}
              style={{ fontFamily: "Arial", marginTop: "0% important" }}
            >
              <div style={{ width: "100%" }}>
                <h1
                  style={{
                    fontSize: "25px",
                    textAlign: "center",
                    paddingTop: index > 0 ? '20px' : ''
                  }}
                >
                  {validateData(brand) ? brand : "-"}
                </h1>
                {
                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '26px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      width: "90%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{ textAlign: "center", display: "inline-block" }}
                    >
                      <span
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-44px",
                        }}
                      >
                        $
                      </span>
                      <span style={{ fontSize: "138px", fontWeight: "bold" }}>
                        {validateData(SplitweeklyRate[0])
                          ? SplitweeklyRate[0]
                          : " - "}
                      </span>
                    </div>
                    <div style={{ textAlign: "center", marginLeft: "8px" }}>
                      <p
                        style={{
                          fontSize: "70px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          marginTop: "15px",
                        }}
                      >
                        {validateData(SplitweeklyRate[1])
                          ? SplitweeklyRate[1]
                          : " - "}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('PER WEEK')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </p>
                      <p
                        style={{ margin: "0px 0px 5px 0px", fontSize: "16px" }}
                      >
                        {t('to Own It')}
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "21px",
                    marginBottom: "8px",
                  }}
                >
                  {t('Additional Flexible Payment Options:')}
                </p>
                <div
                  style={{ width: "100%", float: "left", marginBottom: "15px" }}
                >
                  <div
                    style={{
                      width: "33%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Bi-weekly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter
                            .format(data[index].biWeeklyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? data[index].biWeeklyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "32%",
                      float: "left",
                      borderRight: "1px solid #000",
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Semi-monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter
                            .format(data[index].semiMonthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? data[index].semiMonthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: "32%", float: "left" }}>
                    <p
                      style={{
                        textAlign: "center",
                        fontStyle: "italic",
                        marginBottom: "10px",
                        fontSize: "16px",
                      }}
                    >
                      {t('Monthly')}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        float: "left",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter
                            .format(data[index].monthlyRate)
                            .replace(/^(\D+)/, "$1 ")
                          : "-"}
                        ,
                      </span>
                      <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? data[index].monthlyTerm
                          : "-"}{" "}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "18px",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "8px",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {t('Rent to Own Charge:')}
                  </span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].costOfRental)
                      ? formatter
                        .format(data[index].costOfRental)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                </p>
                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "center",
                    marginTop: "4px",
                    marginBottom: "4px",
                  }}
                >
                  {t('Easy Ownership Options:')}
                </p>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "7px",
                    fontSize: "16px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {t('Retain Value:')}&nbsp;
                  </span>
                  <span style={{ fontWeight: "bold" }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter
                        .format(data[index].sameAsCashPrice)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                  <span style={{ fontWeight: "bold" }}>
                    &nbsp;{t('Same As Cash (SAC)')}
                  </span>
                </div>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) && Number(data[index].sacDaysToPrint) > 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                     // marginBottom: "7px",
                      fontSize: "15px",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>
                      {data[index].sacDaysToPrint}&nbsp;
                    </span>
					          <span style={{ fontWeight: "bold" }}>
                      {t('Days SAC')}
                    </span>
                  </div>
                )}
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "7px",
                    fontSize: "17px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{t('After SAC:')}&nbsp;</span>
                  <span>
                    <span>{t('Purchase early to save on the total cost')} </span>
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: "33px",
                    fontSize: "15px",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    {t('Total Cost of All Payments:')}{" "}
                  </span>
                  <span>
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter
                        .format(data[index].weeklyRate)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}{" "}
                    x{" "}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : "-"}{" "}
                  </span>
                  <span>{t('payments =')}</span>
                  <span>
                    {" "}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter
                        .format(data[index].totalCost)
                        .replace(/^(\D+)/, "$1 ")
                      : "-"}
                  </span>
                </div>
                <div style={{ width: "100%", textAlign: "center" }}>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "22px",
                      fontWeight: "bold",
                      marginBottom: "30px",
                      marginTop: "15px",
                    }}
                  >
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : "-"}
                    {"  "}
                    {/* Previously Rented */}
                  </p>
                  <div className="text-align:center;width:100%" style={{ fontSize: '12px' }}>
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Item:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Model:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : "-"}
                        {"  "}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: "12px" }}>{t('Serial:')} </span>
                      <span style={{ fontSize: "12px" }}>
                        {" "}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : "-"}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix}>
                    <Barcode width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={true}
                      height={48}
                      fontSize={7}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          );
        }
        else if(data[index]?.templateName == 'MXSingleItemPriceTag_n_es'){
          console.log("status",data[index].status)
           const isNewChecked = validateData(data[index].status) && data[index].status == "New";
    const isPreviouslyRentedChecked = validateData(data[index].status) && data[index].status == "Previously Rented";
    console.log("new check",isNewChecked);
          return (
            
          
          <div key={index} style={{ margin: '0', padding: '0', fontFamily: 'Arial', width: '100%', maxWidth: '500px', boxSizing: 'border-box' }}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
          {/* Product title */}
          <div style={{ marginBottom: '15px', marginTop: '40px' }}>
          <span style={{ display: 'block', fontSize: '21px', fontWeight: '600', color: '#000', marginBottom: '10px' ,marginTop:'45px'}}>
          {validateData(brand) ? brand.toUpperCase() : '-'}
          </span>
          <span style={{ fontSize: '16px', color: '#000', lineHeight: '1.2' }}>
          {validateData(data[index]) && validateData(data[index]?.inventoryDescription)
          ? data[index].inventoryDescription.toUpperCase()
          : '-'}
      </span>
    </div>

    {/* Price section */}
    <div style={{ marginBottom: '30px' }}>
      <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', fontSize: '76px', fontWeight: '800', color: '#000', lineHeight: '1', width: '100%' }}>
      <span style={{ flex: '0 0 50px', fontSize: '44px', textAlign: 'center', paddingBottom: '20px' }}>$</span>
      <span style={{ flex: '0 0 100px', fontSize: '88px', textAlign: 'center' }}>
        {validateData(data[index].weeklyRate) ? Math.ceil((parseFloat(data[index].weeklyRate)) + (parseFloat(data[index].weeklyRateTaxAmount))) : '-'}
      </span>
    </span>
      <span style={{ display: 'block', fontSize: '24px', fontWeight: '700', color: '#000',marginTop:'5px' }}>
        SEMANALES
      </span>
      <span style={{ display: 'block', fontSize: '17px', color: '#000', marginBottom: '5px' }}>
        en un plazo de hasta {validateData(data[index]) && validateData(data[index].monthlyTerm) ? data[index].monthlyTerm : 'N/A'} meses
      </span>
      <span style={{ display: 'block', fontSize: '24px', color: '#000' }}>
  <span style={{fontSize : '18px'}}>o</span> <span style={{ fontSize: '20px', fontWeight: 'bold' }}>$</span>
  <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
 {validateData(data[index]) && validateData(data[index]?.totalCost) 
  ? (Math.ceil(
      (parseFloat(data[index]?.totalCost) + 
      (validateData(data[index]?.totalCostTaxAmount) ? parseFloat(data[index]?.totalCostTaxAmount) : 0)) 
      / 2)
    ).toLocaleString() 
  : '-'}
  </span>
  <span style={{ fontSize: '17px', fontWeight: 'normal' }}> precio de contado</span>
</span>
    </div>

    {/* Divider line */}
<div style={{ borderTop: '1px solid #ccc', width: '7.7cm', margin: '10px auto' }}></div>

    {/* Status section */}
<div style={{ fontSize: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px', gap: '30px', marginTop: '5px' }}>
    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', cursor: 'pointer' }}>
        <input 
            type="radio" 
            id="radio1" 
            name="radio-group" 
            style={{ opacity: 0, width: 0, height: 0 }} // Hide the default radio button
            checked={isNewChecked}
            readOnly // Prevents user from directly interacting with the input
        />
        <label htmlFor="radio1" style={{ paddingLeft: '30px', position: 'relative', fontSize: '15px', marginBottom: 0,paddingTop:'6px' }}>
            <span style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '0.66cm', // Set width to 0.66 cm
                height: '0.66cm', // Set height to 0.66 cm
                borderRadius: '50%',
                border: '2px solid #555',
                backgroundColor: isNewChecked ? '#262626' : 'transparent',  // Set background color based on checked state
            }}></span>
            Nuevo
        </label>
    </div>

    <div style={{ display: 'flex', alignItems: 'center', position: 'relative', cursor: 'pointer' }}>
        <input 
            type="radio" 
            id="radio2" 
            name="radio-group" 
            style={{ opacity: 0, width: 0, height: 0 }} // Hide the default radio button
            checked={isPreviouslyRentedChecked}
            readOnly // Prevents user from directly interacting with the input
        />
        <label htmlFor="radio2" style={{ paddingLeft: '30px', position: 'relative', fontSize: '15px', marginBottom: 0 , paddingTop:'6px' }}>
            <span style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '0.66cm', // Set width to 0.66 cm
                height: '0.66cm', // Set height to 0.66 cm
                borderRadius: '50%',
                border: '2px solid #555',
                backgroundColor: isPreviouslyRentedChecked ? '#262626' : 'transparent', // Set background color based on checked state
            }}></span>
            Previamente rentado
        </label>
    </div>
</div>

    {/* QR Code and Product Details */}
<div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginBottom: '30px', marginTop: '10px' }}>
  {/* QR Code */}
  <div style={{ flexShrink: '0', marginRight: '30px', marginTop: '15px', marginLeft: '10px' }}>
    <div style={{ transform: 'scale(1.2)', transformOrigin: 'top left' }}>
      <QRCode style={{ width: '2.35cm', height: '2.35cm', color: '#000' }} aria-label="QR Code" />
    </div>
  </div>

  {/* Product details */}
  <div style={{ marginRight: '10px', flex: '1', marginTop: '10px', textAlign: 'left', fontSize: '14.5px', color: '#000', lineHeight: '1.3' }}>
    <div style={{ marginBottom: '5px' }}>
      Escanea el QR para iniciar 
      <div>tu proceso.</div>
    </div>
    <div style={{ marginBottom: '2px', fontSize: '14.5px', textTransform: 'capitalize' }}><span>Artículo:</span> {validateData(data[index]) && validateData(data[index].inventoryNumber) ? data[index].inventoryNumber : '-'}</div>
    <div style={{ marginBottom: '2px', fontSize: '14.5px', textTransform: 'capitalize' }}><span>Modelo:</span> {validateData(data[index]) && validateData(data[index].model) ? data[index].model : '-'}</div>
    <div style={{ marginBottom: '2px', fontSize: '14.5px', textTransform: 'capitalize' }}><span>Serie:</span> {validateData(data[index]) && validateData(data[index].serialNumber) ? data[index].serialNumber : '-'}</div>
  </div>
</div>

    {/* Barcode */}
    <div className={formClasses.barcodeSizeFix}>
                    <Barcode
                      width={1.5}
                      value={generateBarCodeContent(
                        data[index].inventoryPriceId,
                        data[index].deptRefcode,
                        data[index].subDeptRefcode
                      )}
                      displayValue={false}
                      height={40}
                      fontSize={7}
                      format="CODE128"
                    />{" "}
                  </div>

    {/* Footer */}
    <div style={{ fontSize: '9.3px', color: '#000', textAlign: 'center', lineHeight: '1.2', marginBottom: '5px' }}>
      Precios incluyen IVA. La transacción anunciada es un contrato de renta con opción a compra. Términos y condiciones en www.rac.mx
    </div>
  </div>
</div>
   
          )
        }
        else {
          return (

            <div key={index} style={{ fontFamily: 'Arial', marginTop: '0% important' }}>
              <div style={{ width: '100%' }}>
                <h1 style={{ fontSize: '25px', textAlign: 'center', paddingTop: index > 0 ? '20px' : '' }}>
                  {validateData(brand) ? brand : '-'}
                </h1>
                {
                  data[index]?.inventoryDescription?.length <= 62 ?
                    <p style={{ textAlign: 'center', marginBottom: '26px', fontSize: '15px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p> :
                    <p style={{ textAlign: 'center', marginBottom: '8px', fontSize: '13px' }}>
                      {validateData(data[index]) &&
                        validateData(data[index]?.inventoryDescription)
                        ? data[index].inventoryDescription
                        : '-'}
                    </p>}

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ textAlign: 'center', display: 'inline-block' }}>
                      <span style={{ fontSize: '70px', fontWeight: 'bold', position: 'relative', top: '-44px' }}>$</span>
                      <span style={{ fontSize: '138px', fontWeight: 'bold' }}>
                        {validateData(SplitweeklyRate[0]) ? SplitweeklyRate[0] : ' - '}
                      </span>
                    </div>
                    <div style={{ textAlign: 'center', marginLeft: '8px' }}>
                      <p style={{ fontSize: '70px', fontWeight: 'bold', marginBottom: '10px', marginTop: '15px' }}>
                        {validateData(SplitweeklyRate[1]) ? SplitweeklyRate[1] : ' - '}
                      </p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('PER WEEK')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].weeklyTerm)
                          ? data[index].weeklyTerm
                          : '-'}{' '}
                        {t('Payments')}</p>
                      <p style={{ margin: '0px 0px 5px 0px', fontSize: '16px' }}>{t('to Own It')}</p>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '21px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '24px', marginBottom: '10px' }}>{t('Additional Flexible Payment Options:')}</p>
                <div style={{ width: '100%', float: 'left', marginBottom: '15px' }}>
                  <div style={{ width: '33%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Bi-weekly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyRate)
                          ? formatter.format(data[index].biWeeklyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].biWeeklyTerm)
                          ? (data[index].biWeeklyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left', borderRight: '1px solid #000' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Semi-monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyRate)
                          ? formatter.format(data[index].semiMonthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,
                      </span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].semiMonthlyTerm)
                          ? (data[index].semiMonthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '32%', float: 'left' }}>
                    <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '10px', fontSize: '16px' }}>{t('Monthly')}</p>
                    <div style={{ width: '100%', float: 'left', textAlign: 'center' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyRate)
                          ? formatter.format(data[index].monthlyRate).replace(/^(\D+)/, '$1 ')
                          : '-'}
                        ,</span>
                      <span style={{ marginLeft: '5px', fontSize: '14px' }}>
                        {validateData(data[index]) &&
                          validateData(data[index].monthlyTerm)
                          ? (data[index].monthlyTerm)
                          : '-'}{' '}
                        {t('Payments')}
                      </span>
                    </div>
                  </div>
                </div>
                <p style={{ fontSize: '22px', fontWeight: 'bold', fontStyle: 'italic', textAlign: 'center', marginTop: '10px', marginBottom: '6px' }}>{t('Easy Ownership Options:')}</p>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '18px' }}>
                {validateData(data[index]) && validateData(data[index].sacDaysToPrint) &&
					        Number(data[index].sacDaysToPrint) > 0 ? (
                    <span style={{ fontWeight: "bold" }}>
                    {data[index].sacDaysToPrint} Days&nbsp;
                    </span>
                  ) : null}
                  <span style={{ fontWeight: 'bold' }}>{t('Same As Cash Price (SAC):')}&nbsp;</span>
                  <span style={{ fontWeight: 'bold' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].sameAsCashPrice)
                      ? formatter.format(data[index].sameAsCashPrice).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '7px', fontSize: '18px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('After SAC:')}&nbsp;</span>
                  <span><span style={{ fontWeight: 'bold' }}>{formatEpoPercentage(data[index].epoPercentage)} % </span> {t('off remaining total')}</span>
                </div>
                <div style={{ width: '100%', textAlign: 'center', marginBottom: '42px', fontSize: '18px' }}>
                  <span style={{ fontWeight: 'bold' }}>{t('Total Cost:')} </span>
                  <span>

                    {validateData(data[index]) &&
                      validateData(data[index].weeklyRate)
                      ? formatter.format(data[index].weeklyRate).replace(/^(\D+)/, '$1 ')
                      : '-'}{' '}
                    x{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].weeklyTerm)
                      ? data[index].weeklyTerm
                      : '-'}{' '}
                  </span>
                  <span>payments =</span>
                  <span>{' '}
                    {validateData(data[index]) &&
                      validateData(data[index].totalCost)
                      ? formatter.format(data[index].totalCost).replace(/^(\D+)/, '$1 ')
                      : '-'}
                  </span>
                </div>
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <p style={{ textAlign: 'center', fontSize: '22px', fontWeight: 'bold', marginBottom: '30px', marginTop: '26px' }}>
                    {validateData(data[index]) &&
                      validateData(data[index].status)
                      ? data[index].status
                      : '-'}{'  '}
                    {/* Previously Rented */}
                  </p>
                  <div className="text-align:center;width:100%">
                  {validateData(data[index]) && validateData(data[index].weeklyRateAddOn) &&
                      Number(data[index].weeklyRateAddOn) > 0 ? (
                        <span style={{ fontSize: '12px' }}>
                          {data[index].weeklyRateAddOn} -&nbsp;
                        </span>
                      ) : null}
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Item:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].inventoryNumber)
                          ? data[index].inventoryNumber
                          : '-'}{'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Model:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].model)
                          ? data[index].model
                          : '-'}
                        {'  '}
                      </span>
                    </span>
                    <span>-</span>
                    <span>
                      <span style={{ fontSize: '12px' }}>{t('Serial:')} </span>
                      <span style={{ fontSize: '12px' }}>
                        {' '}
                        {validateData(data[index]) &&
                          validateData(data[index].serialNumber)
                          ? data[index].serialNumber
                          : '-'}
                      </span>
                    </span>
                  </div>
                  <div className={formClasses.barcodeSizeFix} >
                    <Barcode width={1.5} value={generateBarCodeContent(data[index].inventoryPriceId, data[index].deptRefcode, data[index].subDeptRefcode)} displayValue={true} height={48} fontSize={7} format='CODE128' />{' '}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }
    });
  };

  return <div>{PriceTag()}</div>;
};

const generateBarCodeContent = (invPriceId: any, depRefCode: any, SubDepRefCode: any) => {
  if (invPriceId && depRefCode && SubDepRefCode) {
    const BAR_CODE_FORMAT = "%-18s%1s%3s%3s";
    return sprintf(BAR_CODE_FORMAT, invPriceId, "P", depRefCode, SubDepRefCode);
  }
  else if (invPriceId && depRefCode) {
    const BAR_CODE_FORMAT = "%-18s%1s%3s%3s";
    return sprintf(BAR_CODE_FORMAT, invPriceId, "P", depRefCode, depRefCode);
  }
  else if (invPriceId) {
    return `${invPriceId}     P`;
  }
  return '';
}

// export default PrintFunction